import React, { useState, useRef, useEffect } from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import lang from '@/lang'

const useStyles = makeStyles(theme => ({
  shortText: {
    overflow: 'hidden',
    height: 'auto',
    maxHeight: (props) => props.height,
  },
  readMore: {
    display: 'flex',
    paddingTop: 5,
    color: theme.primary,
    fontSize: 12,
    lineHeight: 1,
    letterSpacing: '0.24px',
    cursor: 'pointer',
  },
  flip: {
    transform: 'rotate(180deg)',
  },
}))

const TextReadMore = (props) => {
  const classes = useStyles(props)
  const { onMoreClick, children, height, className, readLessLabel = lang.readLess, readMoreLabel = lang.readMore } = props

  const [showFull, setShowFull] = useState(false)
  const [showReadMore, setShowReadMore] = useState(false)
  const textDiv = useRef()

  const onClick = () => {
    const newState = !showFull
    setShowFull(newState)
    onMoreClick && onMoreClick(newState)
  }

  useEffect(() => {
    setShowReadMore(textDiv.current.scrollHeight > textDiv.current.offsetHeight)
  }, [height, children])

  return (
    <div className={clsx(classes.root, className)}>
      <div ref={textDiv} className={clsx(!showFull && classes.shortText)}>
        {children}
      </div>
      {
        showReadMore && <div className={classes.readMore} onClick={onClick}>
          {showFull ? readLessLabel : readMoreLabel}
          <div className={clsx(showFull && classes.flip, 'icon icon-arr_down')} />
        </div>
      }
    </div>
  )
}

TextReadMore.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  height: PropTypes.string,
  onMoreClick: PropTypes.func,
}

export default TextReadMore
